export default {"src":"/_next/static/media/request_feature.c462b230.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};